import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
/**
 * ReceiptTotal
 */
export const receiptTotalStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	margin: 0;
	color: ${theme.colors.base.textPriceReceipt};
`;
export const StyledReceiptTotal = styled(Typography).attrs({
    variant: 'price-text-lg',
    tagName: 'h3',
}) `
	${receiptTotalStyles}
`;
